var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFireFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF8428",
  d: "M17.356 8.65a.5.5 0 0 0-.857.35c0 .762-.161 1.458-.477 2.07-.493.955-1.296 1.57-1.967 1.945 2.86-6.568-2.718-10.39-2.778-10.43A.498.498 0 0 0 10.5 3c0 2.197-1.463 3.494-2.879 4.75-.346.305-.679.601-.975.897C5.142 10.151 4.5 11.752 4.5 14.001c0 4.135 3.364 7.5 7.5 7.5s7.5-3.365 7.5-7.5c0-2.017-.781-3.968-2.144-5.352"
})));
export default SvgFireFill;